import { render, staticRenderFns } from "./ProjectAssessmentView.vue?vue&type=template&id=483e74b0&scoped=true"
import script from "./ProjectAssessmentView.vue?vue&type=script&lang=js"
export * from "./ProjectAssessmentView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483e74b0",
  null
  
)

export default component.exports